import React, { useState } from 'react';
import './Features.css';

const cards = [
  { icon: '🛡️', title: 'Undetectable Technology', desc: 'Invisible to all proctoring systems — hardware-level bypass leaves no traces or detection risks', delay: '0s' },
  { icon: '✅', title: 'All Proctors Supported', desc: 'Works with any proctoring software: Proctorio, ProctorU, Respondus, Honorlock, Examity & more', delay: '0.1s' },
  { icon: '🎧', title: '24/7 Live Support', desc: 'Round-the-clock assistance in real-time — we\'re always here when you need us', delay: '0.2s' },
  { icon: '🎯', title: 'Multiple Assistance Modes', desc: 'AFK mode, remote helper support, or use Google/ChatGPT yourself — complete freedom of choice', delay: '0.3s' },
  { icon: '👤', title: 'Individual Approach', desc: 'Personalized solution selection for your specific exam type, proctor, and situation', delay: '0.4s' },
  { icon: '📋', title: 'Multiple Use Cases', desc: 'Perfect for university exams, certification tests, technical interviews, work assessments, and remote hiring evaluations', delay: '0.5s' },
];

const Features = () => {
  const [expanded, setExpanded] = useState(new Set());

  const toggle = (i) => {
    setExpanded(prev => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });
  };

  return (
    <section className="features">
      <div className="section-header">
        <h2 className="section-title">Powerful Features</h2>
        <p className="section-subtitle">Everything you need for any proctored assessment</p>
      </div>
      <div className="features-grid">
        {cards.map((c, i) => (
          <div
            key={i}
            className={`feature-card${expanded.has(i) ? ' expanded' : ''}`}
            style={{ animationDelay: c.delay }}
            onClick={() => toggle(i)}
          >
            <div className="feature-icon">{c.icon}</div>
            <h3 className="feature-title">{c.title}</h3>
            <p className="feature-desc">{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
